import { ColumnResizingContextProvider } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { Content } from 'src/contexts/ContentContext';
import { NoData, Table } from 'src/tables/Table';
import { ContentId } from 'src/utils/constants/contentId';
import { UserSetting } from 'src/WebApiController';

import { ReportTableV2Props } from '../ReportTableCommon/ReportTableCommon.types';
import { useReportDetailsTableV2 } from '../ReportTableCommon/useReportDetailsTableV2';
import {
  CommissionReportTableColumnDefContextV2,
  useCommissionReportTableColumnDefV2,
} from './CommissionReportTableColumnDefContextV2';

export const CommissionReportTableV2 = ({
  report,
  reportValueTypes,
  ...rest
}: ReportTableV2Props) => {
  return (
    <CommissionReportTableColumnDefContextV2
      report={report}
      reportValueTypes={reportValueTypes}
    >
      <ReportTableInternal report={report} {...rest} />
    </CommissionReportTableColumnDefContextV2>
  );
};

const ReportTableInternal = (props: ReportTableV2Props) => {
  const { displayedColumnsConfig = [] } = useCommissionReportTableColumnDefV2();

  const { isReportConfigEmpty, tableProps, data } = useReportDetailsTableV2({
    ...props,
    displayedColumnsConfig,
  });

  return isReportConfigEmpty ? (
    <></>
  ) : data?.length > 0 ? (
    <ColumnResizingContextProvider
      userSettingId={UserSetting.ReportV2CommissionColumnWidths}
    >
      <Table {...tableProps} />
    </ColumnResizingContextProvider>
  ) : (
    <NoData>
      <Content id={ContentId.NoReportText} />
    </NoData>
  );
};

export default CommissionReportTableV2;
